import { VideoProps } from '@graphcms/rich-text-types';
import Head from 'next/head';
import React, { useEffect, useState } from 'react';
import YoutubePlayer from '@/components/YoutubePlayer';
import { YouTubeService } from '@/service/google/youTubeService';

interface SchemaVideoProps {
  name?: string;
  description?: string;
  thumbnailUrls?: string[];
  embedUrl?: string;
  uploadDate?: string;
  duration?: string;
  interactionCount?: number;
  video?: string;
  keywords?: string;
  recipeCuisine?: string;
  recipeCategory?: string;
}

type VideoPropsCombined = SchemaVideoProps & Partial<VideoProps>;

export function Video({
  src,
  width,
  height,
  title,
  name,
  description,
  thumbnailUrls,
  embedUrl,
  uploadDate,
  duration,
  interactionCount,
  video,
  keywords,
  recipeCuisine,
  recipeCategory,
}: VideoPropsCombined) {
  const [isClient, setIsClient] = useState(false);

  useEffect(() => {
    setIsClient(true);
  }, []);

  const schemaOrgData = {
    '@context': 'https://schema.org',
    '@type': 'VideoObject',
    name: name,
    description: description,
    video: video,
    keywords: keywords,
    recipeCategory: recipeCategory,
    recipeCuisine: recipeCuisine,
    contentUrl: src,
    ...(thumbnailUrls && { thumbnailUrl: thumbnailUrls }),
    ...(embedUrl && { embedUrl: embedUrl }),
    ...(uploadDate && { uploadDate: uploadDate }),
    ...(duration && { duration: duration }),
    ...(interactionCount && {
      interactionStatistic: {
        '@type': 'InteractionCounter',
        interactionType: { '@type': 'WatchAction' },
        userInteractionCount: interactionCount,
      },
    }),
  };

  const videoId = YouTubeService.getVideoId(video || src || '');

  return (
    <>
      <Head>
        <script type="application/ld+json">{JSON.stringify(schemaOrgData)}</script>
      </Head>
      <div>
        {isClient && videoId && (
          <YoutubePlayer
            videoid={videoId}
            autoplay={false}
            width={width ?? '100%'}
            height={height ?? '100%'}
            playlabel={title}
          />
        )}
      </div>
    </>
  );
}
